var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.display)?_c('div',{staticClass:"tips-box"},[_c('p',{staticClass:"tips-text"},[_vm._v(_vm._s(_vm.content))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }